import {FormStepper, EntityFormGeneralDataSection} from "base/component/form";
import {PoligonoFormCaracteristicasSection, PoligonoFormGeneralDataFields} from ".";

import Box from "@mui/material/Box";

const PoligonoCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<PoligonoFormGeneralDataFields creation={true} />}
        />,
        <PoligonoFormCaracteristicasSection />,
    ];
    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default PoligonoCreationForm;
